module.exports = __webpack_public_path__ + "assets/img/00012.6dda1a93.png";